export enum NewsletterSource {
	NewsletterSection = "NewsletterSection",
	Footer = "Footer",
	ProductDetail = "ProductDetail",
	ContactModal = "ContactModal",
	PopupBar = "PopupBar",
	NewsOtp = "NewsOtp",
	Legacy = "Legacy",
}
